module.exports = __webpack_public_path__ + "static/media/video_off.59dea2e5.png";